export enum DocumentAllowedFileTypes {
    acknowledgement = 'pdf,jpeg,jpg,png,gif',
}
